import React, { useEffect, useRef } from "react";

type SvgIconProps = {
  svgString: string;
  className?: string;
  style?: React.CSSProperties;
  alt?: string;
};

const SvgIcon: React.FC<SvgIconProps> = ({
  svgString,
  className,
  style,
  alt,
}) => {
  const svgContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (svgContainerRef.current) {
      svgContainerRef.current.innerHTML = "";
      const parser = new DOMParser();
      const doc = parser.parseFromString(svgString, "image/svg+xml");
      const svgElement = doc.documentElement;

      if (svgElement.tagName === "svg") {
        svgContainerRef.current.appendChild(svgElement);
      } else {
        // eslint-disable-next-line no-console
        console.error("Provided string is not a valid SVG.");
      }
    }
  }, [svgString]);

  return (
    <div
      className={className}
      style={style}
      role="img"
      aria-label={alt}
      ref={svgContainerRef}
    />
  );
};

export default SvgIcon;
